import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from 'src/app/core/services/theme.service';
import { DeploymentStatusBreakdown } from '../../../../models/patch-management.models';

const DEPLOYMENT_STATUS_COLOR: Record<string, { light: string; dark: string }> = {
  Installed: { light: '#00c100', dark: '#00c100' },
  Failed: { light: '#ea2d0a', dark: '#ff694e' },
  'Reboot Pending': { light: '#f7cb00', dark: '#c68600' },
  'Delay in Deployment': { light: '#ff6a16', dark: '#ffb452' },
  Unknown: { light: '#b9bbbc', dark: '#b9bbbc' },
};
const FALLBACK_COLOR = { light: '#b9bbbc', dark: '#b9bbbc' };

@Component({
  selector: 'app-deployment-status-card',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './deployment-status-card.component.html',
  styleUrls: ['./deployment-status-card.component.scss'],
})
export class DeploymentStatusCardComponent {
  @Input({ required: true }) deploymentStatuses: DeploymentStatusBreakdown[] = [];
  @Input() activeDeploymentStatus: string | null = null;
  @Output() deploymentStatusSelect = new EventEmitter<string>();

  constructor(private themeService: ThemeService) {}

  colorFor(name: string): string {
    const pair = DEPLOYMENT_STATUS_COLOR[name] ?? FALLBACK_COLOR;
    return this.themeService.isInDarkMode() ? pair.dark : pair.light;
  }
}
